<template>
    <div class="">
        <router-view />
        <cookie-law theme="dark-lime--rounded" buttonText="Согласен">
            <div slot="message" >
                Мы используем файлы cookie и рекомендательные технологии. Пользуясь сайтом, вы соглашаетесь с <a href="https://www.katris.ru/personal-dannye" target="_blank" style="text-decoration: underline; color: #fff">Политикой обработки персональных данных.</a>
            </div>
        </cookie-law>
    </div>
</template>

<script>
    import CookieLaw from 'vue-cookie-law'

    export default {
        name: "Login",
        components: {
            CookieLaw
        },
    }
</script>

<style>
.Cookie__button {
    background-color: #007bff !important;
}
.Cookie__button:hover {
    background-color: #0069d9 !important;
}
</style>
